var map = {
	"./Company/resources/components/canvas/blocks/modules/company/admin/BlockPanel.vue": 9846,
	"./Knowledge/resources/components/canvas/blocks/modules/knowledge/admin/BlockPanel.vue": 30896,
	"./Story/resources/components/canvas/blocks/modules/story/admin/BlockPanel.vue": 68942,
	"./Story/resources/components/canvas/blocks/modules/storyHighlightSlider/admin/BlockPanel.vue": 33771,
	"./Story/resources/components/canvas/blocks/modules/storyHighlightSlider/block.js": 78022,
	"./Story/resources/components/canvas/blocks/modules/storySlider/admin/BlockPanel.vue": 75587,
	"./Story/resources/components/canvas/blocks/modules/storySlider/block.js": 34506,
	"./Story/resources/js/livewire/story-list.js": 1117,
	"./Vacancy/resources/components/canvas/blocks/modules/vacancy/admin/BlockPanel.vue": 72422,
	"./WebsiteNews/resources/components/canvas/blocks/modules/news/admin/BlockPanel.vue": 88465,
	"./WebsiteNews/resources/components/canvas/blocks/modules/news/block.js": 24712
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31335;